module.exports = __webpack_public_path__ + "media/images/icon_interact_keyword-a291cefeb2544d61dd06b6ed3016c382.png";